import { __assign } from "tslib";
import * as React from 'react';
import styles from './Image.scss';
import * as imageKit from '@wix/image-kit';
var STATIC_MEDIA_URL = imageKit.STATIC_MEDIA_URL;
var fetchLQIP = function (_a) {
    var fittingType = _a.fittingType, src = _a.src, target = _a.target, options = _a.options;
    var placeholder = imageKit.getPlaceholder(fittingType, src, target, __assign(__assign({}, options), { autoEncode: true }));
    if ((placeholder === null || placeholder === void 0 ? void 0 : placeholder.uri) && !placeholder.uri.startsWith('http')) {
        placeholder.uri = "" + STATIC_MEDIA_URL + placeholder.uri;
    }
    return placeholder;
};
var DEFAULT_CONTAINER_DIM = 200;
var Image = function (props) {
    var _a;
    var id = props.id, containerId = props.containerId, uri = props.uri, alt = props.alt, name = props.name, role = props.role, width = props.width, height = props.height, displayMode = props.displayMode, devicePixelRatio = props.devicePixelRatio, quality = props.quality, alignType = props.alignType, _b = props.bgEffectName, bgEffectName = _b === void 0 ? '' : _b, focalPoint = props.focalPoint, upscaleMethod = props.upscaleMethod, _c = props.className, className = _c === void 0 ? '' : _c, crop = props.crop, _d = props.imageStyles, imageStyles = _d === void 0 ? {} : _d, targetWidth = props.targetWidth, targetHeight = props.targetHeight, _e = props.onLoad, onLoad = _e === void 0 ? function () { } : _e, _f = props.onError, onError = _f === void 0 ? function () { } : _f, shouldUseLQIP = props.shouldUseLQIP, containerWidth = props.containerWidth, containerHeight = props.containerHeight, getPlaceholder = props.getPlaceholder, isInFirstFold = props.isInFirstFold, placeholderTransition = props.placeholderTransition;
    // fix containerId and id to support hoverBox component
    var hasSsrSrc = '';
    var hasBlurTransition = placeholderTransition === 'blur';
    var imageInfo = __assign(__assign(__assign(__assign(__assign({ containerId: containerId }, (alignType && { alignType: alignType })), { displayMode: displayMode }), (targetWidth && { targetWidth: targetWidth })), (targetHeight && { targetHeight: targetHeight })), { imageData: __assign(__assign(__assign(__assign(__assign({ width: width,
            height: height,
            uri: uri,
            name: name,
            displayMode: displayMode }, (quality && { quality: quality })), (devicePixelRatio && { devicePixelRatio: devicePixelRatio })), (focalPoint && { focalPoint: focalPoint })), (crop && { crop: crop })), (upscaleMethod && { upscaleMethod: upscaleMethod })) });
    var imagePlaceholderData = React.useRef(null);
    if (!imagePlaceholderData.current) {
        if (getPlaceholder || shouldUseLQIP) {
            hasSsrSrc = isInFirstFold ? '' : 'true';
            var options = __assign(__assign({ upscaleMethod: upscaleMethod }, (quality ? quality : {})), { shouldLoadHQImage: isInFirstFold, omitBlur: hasBlurTransition });
            imagePlaceholderData.current = (getPlaceholder || fetchLQIP)({
                fittingType: displayMode,
                src: {
                    id: uri,
                    width: imageInfo.imageData.width,
                    height: imageInfo.imageData.height,
                    crop: imageInfo.imageData.crop,
                    name: imageInfo.imageData.name,
                    focalPoint: imageInfo.imageData.focalPoint,
                },
                target: {
                    width: containerWidth || DEFAULT_CONTAINER_DIM,
                    height: containerHeight || DEFAULT_CONTAINER_DIM,
                    alignment: alignType,
                    htmlTag: 'img',
                },
                options: options,
            });
        }
        else {
            // to keep an empty placeholder data
            imagePlaceholderData.current = {
                uri: undefined,
                css: { img: {} },
                attr: { img: {}, container: {} },
            };
        }
    }
    var placeholder = imagePlaceholderData.current;
    var src = placeholder === null || placeholder === void 0 ? void 0 : placeholder.uri;
    var srcset = placeholder === null || placeholder === void 0 ? void 0 : placeholder.srcset;
    var placeholderStyle = (_a = placeholder.css) === null || _a === void 0 ? void 0 : _a.img;
    var classNames = styles.image + " " + className;
    var imgRef = React.useRef(null);
    var handleLoad = React.useCallback(function (event) {
        if (onLoad) {
            onLoad(event);
        }
        if (placeholderTransition && imgRef.current) {
            if ((getPlaceholder || shouldUseLQIP) && !isInFirstFold) {
                imgRef.current.onload = function () {
                    imgRef.current.dataset.loadDone = '';
                };
            }
            else {
                imgRef.current.dataset.loadDone = '';
            }
        }
    }, [
        onLoad,
        placeholderTransition,
        isInFirstFold,
        shouldUseLQIP,
        getPlaceholder,
    ]);
    return isInFirstFold ? (React.createElement("div", { id: id, className: classNames, "data-animate-blur": hasBlurTransition ? '' : undefined },
        React.createElement("img", { ref: imgRef, src: src, alt: alt, role: role, style: __assign(__assign({}, placeholderStyle), imageStyles), onLoad: handleLoad, onError: onError, srcSet: srcset.dpr
                .map(function (s) { return "" + STATIC_MEDIA_URL + s; })
                .join(', ') }))) : (React.createElement("wix-image", { id: id, class: classNames, "data-image-info": JSON.stringify(imageInfo), "data-bg-effect-name": bgEffectName, "data-has-ssr-src": hasSsrSrc, "data-animate-blur": hasBlurTransition ? '' : undefined },
        React.createElement("img", { ref: imgRef, src: src, alt: alt, role: role, style: __assign(__assign({}, placeholderStyle), imageStyles), onLoad: handleLoad, onError: onError })));
};
export { Image, imageKit };
//# sourceMappingURL=Image.js.map